"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const nullable = (x) => t.union([x, t.null]);
const SaleItemsBundledMessage = t.type({
    event: t.literal('SALE_ITEMS_BUNDLED'),
    payload: t.type({}),
});
const ItemBundlesBrokenUpMessage = t.type({
    event: t.literal('ITEM_BUNDLES_BROKEN_UP'),
    payload: t.type({}),
});
const ItemUpdatedMessage = t.type({
    event: t.literal('ITEM_UPDATED'),
    payload: t.type({
        itemId: t.number,
    }),
});
const ProbableSurplusSuggestionMessage = t.type({
    event: t.literal('PROBABLE_SURPLUS_SUGGESTION'),
    payload: t.type({
        suggestions: t.array(t.type({
            itemId: t.number,
            suggestedProbableSurplusAmount: t.number,
        })),
    }),
});
const PaymentCreatedMessage = t.type({
    event: t.literal('PAYMENT_CREATED'),
    payload: t.type({
        paymentId: t.number,
    }),
});
const OrderStateChanged = t.type({
    event: t.literal('ORDER_STATE_CHANGED'),
    payload: t.type({
        paymentId: t.number,
        orderState: t.string,
    }),
});
const LocationRatingMessage = t.type({
    event: t.literal('LOCATION_RATING'),
    payload: t.type({
        userId: t.number,
        locationId: t.number,
        score: nullable(t.number),
        motivation: nullable(t.string),
    }),
});
const LocationFollowedMessage = t.type({
    event: t.literal('LOCATION_FOLLOWED'),
    payload: t.type({
        locationId: t.number,
        userId: t.number,
    }),
});
const SaleChangedMessage = t.type({
    event: t.literal('SALE_CHANGED'),
    payload: t.type({
        saleid: t.number,
    }),
});
const GenericTextMessage = t.type({
    event: t.literal('GENERIC_TEXT'),
    payload: t.type({
        textContent: t.string,
    }),
});
const NewRetailerMessageMessage = t.type({
    event: t.literal('NEW_RETAILER_MESSAGE'),
    payload: t.type({}),
});
const ItemsImported = t.type({
    event: t.literal('ITEMS_IMPORTED'),
    payload: t.type({
        source: t.literal('DELIVERECT'),
    }),
});
const TabMemberRequest = t.type({
    event: t.literal('TAB_MEMBER_REQUEST'),
    payload: t.type({
        tabMemberRequestUUID: io_ts_types_1.UUID,
        tabUUID: io_ts_types_1.UUID,
        action: t.union([
            t.literal('requested'),
            t.literal('accepted'),
            t.literal('rejected'),
            t.literal('cancelled'),
        ]),
    }),
});
const TabMembersChanged = t.type({
    event: t.literal('TAB_MEMBERS_CHANGED'),
    payload: t.type({
        tabUUID: io_ts_types_1.UUID,
        tabMemberUUID: io_ts_types_1.UUID,
        action: t.union([t.literal('ADDED'), t.literal('REMOVED')]),
    }),
});
const KitechenDispatchState = t.union([
    t.literal('not_sent'),
    t.literal('staged_awaiting_payment'),
    t.literal('pending'),
    t.literal('merged'),
    t.literal('waiting_for_merge'),
    t.literal('accepted'),
    t.literal('in_preparation'),
    t.literal('ready_to_deliver'),
    t.literal('delivered'),
    t.literal('rejected'),
    t.literal('rejected_and_acknowledged'),
]);
const KitechenDispatchUpdated = t.type({
    event: t.literal('KITCHEN_DISPATCH_UPDATED'),
    payload: t.type({
        state: KitechenDispatchState,
        kitchenDispatchUUID: io_ts_types_1.UUID,
    }),
});
const KitchenDispatchItemsChanged = t.type({
    event: t.literal('KITCHEN_DISPATCH_ITEMS_CHANGED'),
    payload: t.type({
        kitchenDispatchUUID: io_ts_types_1.UUID,
    }),
});
const TabUpdated = t.type({
    event: t.literal('TAB_UPDATED'),
    payload: t.type({
        tabUUID: io_ts_types_1.UUID,
    }),
});
const TabSettlementUpdated = t.type({
    event: t.literal('TAB_SETTLEMENT_UPDATED'),
    payload: t.type({
        tabUUID: io_ts_types_1.UUID,
        tabSettlementUUID: io_ts_types_1.UUID,
    }),
});
const SessionExpired = t.type({
    event: t.literal('SESSION_EXPIRED'),
    payload: t.unknown,
});
const PaymentAccountAvailable = t.type({
    event: t.literal('PAYMENT_ACCOUNT_AVAILABLE'),
    payload: t.type({
        account: t.string,
        accountId: t.number,
    }),
});
exports.Message = t.union([
    GenericTextMessage,
    ItemBundlesBrokenUpMessage,
    ItemsImported,
    ItemUpdatedMessage,
    KitchenDispatchItemsChanged,
    KitechenDispatchUpdated,
    LocationFollowedMessage,
    LocationRatingMessage,
    NewRetailerMessageMessage,
    OrderStateChanged,
    PaymentAccountAvailable,
    PaymentCreatedMessage,
    ProbableSurplusSuggestionMessage,
    SaleChangedMessage,
    SaleItemsBundledMessage,
    SessionExpired,
    TabMemberRequest,
    TabMembersChanged,
    TabSettlementUpdated,
    TabUpdated,
]);
